import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { showToast } from '../../utils/toast';
import { toggleLike, checkLiked } from '../../services/boardService';

function BoardLikeButton({ type, threadId, targetId, initialLikesCount }) {
  const { currentUser } = useAuth();
  const [liked, setLiked] = useState(false);
  const [likesCount, setLikesCount] = useState(initialLikesCount);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!currentUser) return;
    checkLiked(type, threadId, targetId, currentUser.uid)
      .then((result) => setLiked(result))
      .catch(() => {});
  }, [currentUser, type, threadId, targetId]);

  const handleClick = async () => {
    if (!currentUser) {
      showToast({ message: 'いいねするにはログインが必要です', type: 'info' });
      return;
    }
    setLoading(true);
    try {
      await toggleLike(type, threadId, targetId, currentUser.uid, liked);
      setLiked(!liked);
      setLikesCount((prev) => prev + (liked ? -1 : 1));
    } catch {
      showToast({ message: 'いいねに失敗しました', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={loading}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        fontSize: '12px',
        padding: '2px 10px',
        borderRadius: '9999px',
        border: liked ? '1px solid #fca5a5' : '1px solid #d1d5db',
        background: liked ? '#fff1f2' : 'transparent',
        color: liked ? '#ef4444' : '#6b7280',
        cursor: loading ? 'not-allowed' : 'pointer',
        opacity: loading ? 0.5 : 1,
      }}
      aria-label={liked ? 'いいねを取り消す' : 'いいねする'}
    >
      <span>{liked ? '♥' : '♡'}</span>
      <span>{likesCount}</span>
    </button>
  );
}

export default BoardLikeButton;
